import{
    FETCH_HARDWARE_SOLD_LOADING,
    FETCH_HARDWARE_SOLD_SUCCESS,
    FETCH_HARDWARE_SOLD_FAIL,
    
    FETCH_HARDWARE_CRAFTED_LOADING,
    FETCH_HARDWARE_CRAFTED_SUCCESS,
    FETCH_HARDWARE_CRAFTED_FAIL,
    
    FETCH_HARDWARE_ACTIVE_LOADING,
    FETCH_HARDWARE_ACTIVE_SUCCESS,
    FETCH_HARDWARE_ACTIVE_FAIL,
    
    FETCH_HARDWARE_ACTIVATED_LOADING,
    FETCH_HARDWARE_ACTIVATED_SUCCESS,
    FETCH_HARDWARE_ACTIVATED_FAIL,

    FETCH_HARDWARE_DRINKS_LOADING,
    FETCH_HARDWARE_DRINKS_SUCCESS,
    FETCH_HARDWARE_DRINKS_FAIL,

    FETCH_HARDWARE_DETAILS_LOADING,
    FETCH_HARDWARE_DETAILS_SUCCESS,
    FETCH_HARDWARE_DETAILS_FAIL,

    FETCH_HARDWARE_ING_HISTORY_LOADING,
    FETCH_HARDWARE_ING_HISTORY_SUCCESS,
    FETCH_HARDWARE_ING_HISTORY_FAIL,

    FETCH_HARDWARE_USERS_LOADING,
    FETCH_HARDWARE_USERS_SUCCESS,
    FETCH_HARDWARE_USERS_FAIL,

    FETCH_HARDWARE_RECENT_DRINKS_LOADING,
    FETCH_HARDWARE_RECENT_DRINKS_SUCCESS,
    FETCH_HARDWARE_RECENT_DRINKS_FAIL,

    FETCH_HARDWARE_MOST_REPEATED_DRINKS_LOADING,
    FETCH_HARDWARE_MOST_REPEATED_DRINKS_SUCCESS,
    FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL,

    FETCH_PAGINATED_DEVICES_LOADING,
    FETCH_PAGINATED_DEVICES_SUCCESS,
    FETCH_PAGINATED_DEVICES_FAIL,
    SET_PAGINATED_DEVICES_PAGE,

    FETCH_HARDWARE_LAST_CONNECTED_HISTORY_LOADING,
    FETCH_HARDWARE_LAST_CONNECTED_HISTORY_SUCCESS,
    FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL,

    FETCH_HARDWARE_CLEANING_HISTORY_LOADING,
    FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS,
    FETCH_HARDWARE_CLEANING_HISTORY_FAIL,

} from "../actions/types";

const INITIAL_STATE = {
    //Cleaning History per Station/Device
    cleaning_history: [],
    loading_cleaning_history: false,
    cleaning_history_error: null,
    // Last Connected History
    last_connected_history: [],
    loading_last_connected_history: false,
    last_connected_history_error: null,
    //Paginated Devices
    paginated_devices: [],
    paginated_devices_total: 0,
    paginated_devices_loading: false,
    paginated_devices_error: null,
    paginated_devices_page: 1,
    paginated_devices_perPage: 20,
    //HW Most Repeated Drinks
    most_repeated_drinks: [],
    loading_most_repeated_drinks: true,
    error_most_repeated_drinks: null,
    //HW Recent Drinks
    recent_drinks: [],
    loading_recent_drinks: false,
    recent_drinks_error: null,
    //HW Users
    hardware_users_info: [],
    hardware_users_error: null,
    loading_hardware_users: false,
    // HW Station Details
    hardware_details_info: {
        stations: [],
        last_connected: null
    },
    hw_details_error: null,
    loading_hw_details: true,
    //HW Drinks
    hardware_drinks_info: {
      drinks: [],
        total: 0,
      page: 1,
      perPage: 20
    },
    hardware_drinks_error: null,
    loading_hardware_drinks: false,
    //HW SOLD
    hw_sold_info: [],
    hw_sold_error: null,
    loading_hw_sold: true,

    //HW ACTIVATED
    hw_activated_info: [],
    hw_activated_error: null,
    loading_hw_activated: true,

    //HW CRAFTED
    hw_crafted_info: [],
    hw_crafted_error: null,
    loading_hw_crafted: true,

    //HW CRAFTED
    hw_active_info: [],
    hw_active_error: null,
    loading_hw_active: true,

    //HW ING HISTORY
    hw_ing_history: [],
    hw_ing_history_error: null,
    loading_hw_ing_history: true,
};

const hardwareReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //Cleaning History per Station/Device
        case FETCH_HARDWARE_CLEANING_HISTORY_LOADING:
            return { ...state, loading_cleaning_history: true, cleaning_history_error: null };

        case FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS:
            return {
                ...state,
                cleaning_history: action.payload,
                loading_cleaning_history: false,
                cleaning_history_error: null,
            };

        case FETCH_HARDWARE_CLEANING_HISTORY_FAIL:
            return {
                ...state,
                cleaning_history: [],
                loading_cleaning_history: false,
                cleaning_history_error: action.payload,
            };
        // Last Connected History
        case FETCH_HARDWARE_LAST_CONNECTED_HISTORY_LOADING:
            return { ...state, loading_last_connected_history: true, last_connected_history_error: null };

        case FETCH_HARDWARE_LAST_CONNECTED_HISTORY_SUCCESS:
            return {
                ...state,
                hardware_last_connected_history: action.payload.map((entry) => {
                    const date = new Date(entry.last_connected);
                    return {
                        time: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                        date: date.toLocaleDateString('en-GB'),  // Assuming you're using dd/mm/yyyy format
                    };
                }),
                loading_last_connected_history: false,
                last_connected_history_error: null,
            };

        case FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL:
            return {
                ...state,
                last_connected_history: [],
                loading_last_connected_history: false,
                last_connected_history_error: action.payload,
            };
        //Paginated Device
        case SET_PAGINATED_DEVICES_PAGE:
            return { ...state, paginated_devices_page: action.payload };
        case FETCH_PAGINATED_DEVICES_LOADING:
            return {
                ...state,
                paginated_devices_loading: true,
                paginated_devices_error: null
            };
        case FETCH_PAGINATED_DEVICES_SUCCESS:
            return {
                ...state,
                paginated_devices: action.payload.devices,
                paginated_devices_total: action.payload.total,
                paginated_devices_page: action.payload.page,
                paginated_devices_perPage: action.payload.perPage,
                paginated_devices_loading: false,
            };
        case FETCH_PAGINATED_DEVICES_FAIL:
            return {
                ...state,
                paginated_devices_loading: false,
                paginated_devices_error: action.payload,
                paginated_devices: [],
                paginated_devices_total: 0
            };
        //Most Repeated Drinks
        case FETCH_HARDWARE_MOST_REPEATED_DRINKS_LOADING:
            return {
                ...state,
                loading_most_repeated_drinks: true,
                error_most_repeated_drinks: null,
            };
        case FETCH_HARDWARE_MOST_REPEATED_DRINKS_SUCCESS:
            return {
                ...state,
                most_repeated_drinks: action.payload,
                loading_most_repeated_drinks: false,
                error_most_repeated_drinks: null,
            };
        case FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL:
            return {
                ...state,
                most_repeated_drinks: [],
                loading_most_repeated_drinks: false,
                error_most_repeated_drinks: action.payload,
            };
        // Recent Drinks
        case FETCH_HARDWARE_RECENT_DRINKS_LOADING:
            return { ...state, loading_recent_drinks: true, recent_drinks_error: null };
        case FETCH_HARDWARE_RECENT_DRINKS_SUCCESS:
            return { ...state, recent_drinks: action.payload, loading_recent_drinks: false };
        case FETCH_HARDWARE_RECENT_DRINKS_FAIL:
            return { ...state, recent_drinks: [], loading_recent_drinks: false, recent_drinks_error: action.payload };
        // Device Users
        case FETCH_HARDWARE_USERS_LOADING:
            return { ...state, loading_hardware_users: true, hardware_users_error: null };

        case FETCH_HARDWARE_USERS_SUCCESS:
            return {
                ...state,
                hardware_users_info: action.payload,
                hardware_users_error: null,
                loading_hardware_users: false,
            };

        case FETCH_HARDWARE_USERS_FAIL:
            return {
                ...state,
                hardware_users_info: [],
                hardware_users_error: action.payload,
                loading_hardware_users: false,
            };
        // Hardware Ingredients History
        case FETCH_HARDWARE_ING_HISTORY_LOADING:
        return { ...state, loading_hw_ing_history: true };

        case FETCH_HARDWARE_ING_HISTORY_SUCCESS:
        return {
            ...state,
            hw_ing_history: action.payload,
            hw_ing_history_error: null,
            loading_hw_ing_history: false,
        };

        case FETCH_HARDWARE_ING_HISTORY_FAIL:
        return {
            ...state,
            hw_ing_history: [],
            hw_ing_history_error: action.payload,
            loading_hw_ing_history: false,
        };
        // Hardware Station Details
        case FETCH_HARDWARE_DETAILS_LOADING:
            return { ...state, loading_hw_details: true };
case FETCH_HARDWARE_DETAILS_SUCCESS: {
  // action.payload looks like { stations: [...], last_connected: "2025-06-26T04:02:51.000Z" }
  const { stations, last_connected } = action.payload;

  return {
    ...state,
    loading_hw_details:    false,
    hw_details_error:      null,
    hardware_details_info: {
      last_connected,
      stations: stations.map(s => ({
        ...s,
        // normalize the API’s "-" into null so your UI never tries new Date("-")
        last_cleaned: s.last_cleaned === "-" ? null : s.last_cleaned
      }))
    }
  };
}

case FETCH_HARDWARE_DETAILS_FAIL:
  return {
    ...state,
    hardware_details_info: { stations: [], last_connected: null },
    hw_details_error: action.payload,
    loading_hw_details: false,    // ← also flip off on error
  };
        case FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS: {
        // Always include stations 1–6, filling missing ones with empty dates[]
        const normalized = [];
        for (let i = 1; i <= 6; i++) {
            const found = action.payload.find(e => Number(e.station) === i);
            normalized.push(found || { station: i, dates: [] });
        }
        return {
            ...state,
            cleaning_history: normalized,
            loading_cleaning_history: false,
            cleaning_history_error: null,
        };
        }
        case FETCH_HARDWARE_DETAILS_FAIL:
            return {
                ...state,
                 hardware_details_info: { stations: [], last_connected: null },
                hw_details_error: action.payload,
                loading_hw_details: false,
            };

        // Hardware Drinks Paginated
        case FETCH_HARDWARE_DRINKS_LOADING:
            return { 
                ...state, 
                loading_hardware_drinks: true,
                hardware_drinks_error: null,
            };
        case FETCH_HARDWARE_DRINKS_SUCCESS:
            return { 
                ...state, 
                hardware_drinks_info: action.payload,
                hardware_drinks_error: null, 
                loading_hardware_drinks: false 
            };
        case FETCH_HARDWARE_DRINKS_FAIL:
            return { 
                ...state, 
                hardware_drinks_info: {
                    drinks: [],
                    total: 0,
                    page: 1,
                    perPage: 20
                }, 
                hardware_drinks_error: action.payload, 
                loading_hardware_drinks: false 
            };

        //Hardware Sold - HW Page
        case FETCH_HARDWARE_SOLD_FAIL:
            return { ...state, 
                hw_sold_info: [], 
                hw_sold_error: action.payload, 
                loading_hw_sold: false 
            };

        case FETCH_HARDWARE_SOLD_LOADING:
            return { ...state, loading_hw_sold: true };
            
        case FETCH_HARDWARE_SOLD_SUCCESS:
            // console.log('Payload in reducer FETCH_HW_SOLD_SUCCESS:');
            return { 
                ...state, 
                hw_sold_info: action.payload,
                hw_sold_error: null, 
                loading_hw_sold: false 
            };

        //Hardware Activated - HW Page
        case FETCH_HARDWARE_ACTIVATED_FAIL:
            return { ...state, 
                hw_activated_info: [], 
                hw_activated_error: action.payload, 
                loading_hw_activated: false 
            };
        case FETCH_HARDWARE_ACTIVATED_LOADING:
            return { ...state, loading_hw_activated: true };
        case FETCH_HARDWARE_ACTIVATED_SUCCESS:
        // console.log('Payload in reducer FETCH_HW_SOLD_SUCCESS:');
            return { 
                ...state, 
                hw_activated_info: action.payload,
                hw_activated_error: null, 
                loading_hw_activated: false 
            };
        
        // H/W Crafted 
        case FETCH_HARDWARE_CRAFTED_FAIL:
            return { ...state, 
                hw_crafted_info: [], 
                hw_crafted_error: action.payload, 
                loading_hw_crafted: false 
            };
        case FETCH_HARDWARE_CRAFTED_LOADING:
            return { ...state, loading_hw_crafted: true };
        case FETCH_HARDWARE_CRAFTED_SUCCESS:
        // console.log('Payload in reducer FETCH H/W CRAFTED:');
            return { 
                ...state, 
                hw_crafted_info: action.payload,
                hw_crafted_error: null, 
                loading_hw_crafted: false 
            };

        // H/W Active 
        case FETCH_HARDWARE_ACTIVE_FAIL:
            return { ...state, 
                hw_active_info: [], 
                hw_active_error: action.payload, 
                loading_hw_active: false 
            };
        case FETCH_HARDWARE_ACTIVE_LOADING:
            return { ...state, loading_hw_active: true };
        case FETCH_HARDWARE_ACTIVE_SUCCESS:
        // console.log('Payload in reducer FETCH H/W CRAFTED:');
            return { 
                ...state, 
                hw_active_info: action.payload,
                hw_active_error: null, 
                loading_hw_active: false 
            };                


        default:
            return state;
        }
    };
      
export default hardwareReducer;